<template>
  <div class="view-container">
    <div class="content">
      <br />
      <div class="row">
          <span>
              Please provide a password for your new <strong>Online Ordering Account</strong>.
          </span>
          <br />
          <span>
              <strong>Note:</strong> This will be used to login to your account.
          </span>
      </div>
      <br />
      <div class="row form-group">
          <label class="control-label col-xs-12">Password</label>
          <div class="input-group col-xs-12">
              <span class="input-group-addon"><i class="fa fa-lock fa-fw"></i></span>
              <input type="password" id="inputPassword" name="Password" data-minlength="6" class="form-control" data-error="A password with a minumum of 6 characters must be supplied." v-model="password" required />
          </div>
          <div class="help-block with-errors"></div>
      </div>
      <div class="row form-group">
          <label class="control-label col-xs-12">Confirm password</label>
          <div class="input-group col-xs-12">
              <span class="input-group-addon"><i class="fa fa-lock fa-fw"></i></span>
              <input type="password" name="ConfirmPassword" class="form-control" data-match="#inputPassword" data-match-error="Oops. It seems the passwords do not match." v-model="confirmPassword" required />
          </div>
          <div class="help-block with-errors"></div>
      </div>
      <div class="row form-group">
          <button type="submit" name="Activate" class="btn btn-success pull-right" @click="create">Activate</button>
      </div>
    </div>
  </div>
</template>
<!-- Scripts -->
<script>
export default {
  name: "Activate",
  components: {
  },
  data() {
    return {
      franchiseID: this.$route.query.franchiseID,
      emailAddress: this.$route.query.emailAddress,
      token: this.$route.query.token,
      password: '',
      confirmPassword: ''
    }
  },
  methods:{
    create: function(){
      var _self = this;

      var data = {
        FranchiseID: _self.franchiseID,
        EmailAddress: _self.emailAddress,
        Token: _self.token,
        Password: _self.password,
        ConfirmPassword: _self.confirmPassword
      };
      _self.$ooApi.orders.accounts.create.v1(data)
        .then(function (response) {
          if(response.success){
              localStorage.setItem('userToken', response.data.token);
              localStorage.setItem('userMembershipID', response.data.membershipUserId);
              _self.$ooApi.authenticate(data.EmailAddress, data.Password).then(function () {
                  _self.$isLoggedIn = true;
                  _self.$router.push({ path: 'Menu', query: { franchiseID: data.FranchiseID }});
              })
          }
          else
              console.log(response.message);
        });
    }
  }
};
</script>
<style>
    @import './Activate.vue.css'; 
</style>
